import { httpGet, httpPost, httpPut, httpDelete } from '@/utils/request';

export const user_login = (data) => httpPost('/admin/auth/userLogin', data);

// 发送短信验证码
export const sendSmsCode = (data) => httpPost('/admin/auth/send-sms', data);

// 短信验证码登录
export const smsLogin = (data) => httpPost('/admin/auth/userLogin', data);

// 登录信息
export const user_login_info = (data) => httpGet('/admin/user/loginInfo', data);

// 退出登录
export const user_logout = (data) => httpGet('/admin/auth/userLogout', data);

// 修改用户信息
export const edit_user = (data) => httpPost('/admin/editMyInfo', data);